module.exports = __webpack_public_path__ + "img/slide-3.fac2fe07.jpg";